import axios from "axios";
import attachAuthToken from "./attachAuthToken";
import handleExpiredSession from "./handleExpiredSession";

const baseURL = process.env.REACT_APP_API_BASE_URL;

// ORSEE API client: sends the participant token, ends the session on 401.
const axiosInstance = handleExpiredSession(
  attachAuthToken(
    axios.create({
      baseURL,
      headers: {
        post: {
          "Content-Type": "application/json",
        },
      },
    })
  )
);

export default axiosInstance;
